import { Collapse } from 'antd';
import styled, { css } from 'styled-components';

export const Strong = styled.strong`
    font-weight: 600;
`;

export const CardItem = styled.li<{ error?: boolean }>`
    list-style: none;
    background: ${({ error }) => (error ? 'var(--error-background)' : 'var(--gray-1)')};
    border: 1px solid ${({ error }) => (error ? 'var(--error-normal)' : 'transparent')};
    border-radius: 8px;
    padding: 16px 24px;
`;

export const HeaderRow = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
`;

export const HeaderLeft = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    flex: 1;
    min-width: 0;
`;

export const IconWrap = styled.div`
    padding: 8px;
    border-radius: 6px;
    background: var(--brand-1);
    color: var(--brand-6);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    flex-shrink: 0;
`;

export const ContentWrap = styled.div`
    flex: 1;
    min-width: 0;
`;

export const MetaText = styled.div`
    font-size: 14px;
    line-height: 22px;
    color: var(--gray-8);
`;

export const InfoRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px 24px;
`;

export const FooterRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-top: 16px;
`;

export const ProductsList = styled.div`
    max-height: 400px;
    overflow-y: auto;
`;

export const ProductCell = styled.div`
    display: table-cell;
    padding: 8px;
`;

// A row of an anonymous table, which is not painted by a background or a border of its own - the
// cells are what carries the highlight of a failing item, the corner ones its rounded corners,
// because a `table-row` takes neither a background nor a radius.
export const ProductRow = styled.div<{ error?: boolean }>`
    display: table-row;

    &:not(:last-child) {
        ${ProductCell} {
            border-bottom: 1px solid var(--gray-4);
        }
    }

    ${({ error }) =>
        error &&
        css`
            && ${ProductCell} {
                background: var(--error-background);
                border-block: 1px solid var(--error-normal);
            }

            && ${ProductCell}:first-child {
                border-left: 1px solid var(--error-normal);
                border-radius: 6px 0 0 6px;
            }

            && ${ProductCell}:last-child {
                border-right: 1px solid var(--error-normal);
                border-radius: 0 6px 6px 0;
            }
        `}
`;

export const ActionsCell = styled(ProductCell)`
    width: 1%;
    white-space: nowrap;
`;

export const StyledCollapse = styled(Collapse)`
    .ant-collapse-header {
        padding: 0 !important;
    }
`;
